export const EVENTS = {
    BACK_TO_DATA_SELECTOR: 'BACK_TO_DATA_SELECTOR',
    SHOW_FUNCTION_DESIGNER: 'SHOW_FUNCTION_DESIGNER',
    CLOSED_FUNCTION_DESIGNER: 'CLOSED_FUNCTION_DESIGNER',
	DEFAULT_VALUE_CHANGED: 'DEFAULT_VALUE_CHANGED',
    METHOD_SELECTED: 'METHOD_SELECTED',
    EDIT_QUERY: 'EDIT_QUERY',
    SHOW_FUNCTION_DESIGNER_REQUESTED: 'SHOW_FUNCTION_DESIGNER_REQUESTED'
}